export default __webpack_public_path__ + "static/media/bg-character-img-4.2e7b77dd.png";